<p>
  Функцията за последване ви позволява да изградите собствена мрежа от потребители, чиито обяви и активности искате да
  следите отблизо.
</p>
<h6 class="mt-3">Как да последвате потребител?</h6>
<p>
  Навигирайте до <strong>профила на съответния потребител</strong> и натиснете бутона <strong>„Започни да
  следваш“</strong>.
  Веднага след това потребителят ще бъде добавен към вашия списък с последвани.
</p>
<h6 class="mt-3">
  Къде да намерите последваните потребители?
</h6>
<p>
  Всички последвани от вас профили са достъпни в секцията <strong>„Профил“ → „Последвани потребители“</strong>. Оттам
  може бързо да достигате до техните обяви.
</p>
<h6 class="mt-3">
  Как да спрете да следвате?
</h6>
<p>
  За да прекратите следенето, отворете отново профила на съответния потребител и натиснете бутона
  <strong>„Спри да следваш“</strong>. Може да направите това и директно от списъка с последвани.
</p>
<h6 class="mt-3">
  Кой ви следва?
</h6>
<p>
  Потребителите, които следват вашия профил, се показват в секцията <strong>„Профил“ → „Моите последователи“</strong>.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Използвайте функцията за последване, за да следите търговци или колекционери, които ви правят
  впечатление с активността си или предлаганите артикули.
</div>
